import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import { mcpTokenStatusesQueryKey } from "./useMcpTokenStatuses";

export function useDisconnectMcpServer(orgId: string | undefined) {
  const { mcpRegistryService } = useDomainServices();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (serverId: string) =>
      mcpRegistryService.disconnectServer(serverId, orgId!),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: mcpTokenStatusesQueryKey(orgId),
      });
    },
  });
}
